"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withHook = _interopRequireDefault(require("@store/utils/lib/withHook"));

var _link = require("@meepshop/link");

var _DecoratorsRoot = require("../layout/DecoratorsRoot");

var _propTypes2 = require("../constants/propTypes");

var _Menu = _interopRequireDefault(require("./Menu"));

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var NewMenu = (_dec = (0, _withHook["default"])(function () {
  return {
    router: (0, _link.useRouter)()
  };
}), _dec(_class = (0, _DecoratorsRoot.enhancer)(_class = (_temp = _class2 = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(NewMenu, _React$PureComponent);

  var _super = _createSuper(NewMenu);

  function NewMenu() {
    (0, _classCallCheck2["default"])(this, NewMenu);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(NewMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          menu = _this$props.menu,
          id = _this$props.id;
      if (!menu) return null;
      return /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
        id: id,
        menu: menu
      });
    }
  }]);
  return NewMenu;
}(_react["default"].PureComponent), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /** props */
  id: _propTypes["default"].string,
  menu: _propTypes["default"].shape({
    iconSize: _propTypes["default"].oneOf([24, 32, 48]).isRequired,
    logoAlignment: _propTypes["default"].oneOf(['LEFT', 'RIGHT']).isRequired,
    pages: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes2.ID_TYPE.isRequired
    }).isRequired),
    design: _propTypes["default"].shape({}).isRequired
  }).isRequired
}), _temp)) || _class) || _class);
exports["default"] = NewMenu;